import axios from "axios";
import router from '@/router'
import store from '@/store'
import Swal from 'sweetalert2/dist/sweetalert2.js'


const BackendService = axios.create({
    baseURL: process.env.VUE_APP_API_SERVICE,
    withCredentials: true,
    headers: {
        "Content-type": 'application/json',
        "Accept": 'application/json',
    }
})

BackendService.interceptors.request.use(config => {
    let token = ''

    try {
        let userStorage = localStorage.getItem('token')
        token = userStorage
    } catch (error) {
        console.log(error);
    }

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config
})

BackendService.interceptors.response.use(undefined, function (error) {
    if (error) {
        if (error.response.status === 401 && error.config.url != "getNotiSideBar") {
            store.replaceState({ defaultSystem: {} });
            localStorage.clear();
            store.commit("defaultSystem/SET_USER", null, { root: true });
            store.commit("defaultSystem/SET_TOKEN", null, { root: true });
            router.push({
                name: "login",
            }).then(() => {
                location.reload();
            });
            return;
        }
        if (error.response.status === 400) {
            Swal.fire({
                icon: "error",
                title: "Oops! error",
                text: error.response.data.message,
                showConfirmButton: true,
                confirmButtonColor: 'red',
                confirmButtonText: 'ตกลง'
            });
        }
        throw error
    }
})


export default BackendService